import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1332bd4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "header-box" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = ["onMouseup"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"cursor":"pointer"} }, "静，而知之", -1))
const _hoisted_6 = [
  _hoisted_5
]

import Menu from "./Menu.vue";
import { useStore } from "@/store";
import apis from "@/api/user";
import type { Result } from "@/utils/http/types";
import { ref } from "@vue/reactivity";
import { message } from "ant-design-vue";
import { Storage } from "@/utils/Storage";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const visible = ref(false);
const confirmLoading = ref(false);
const password = ref("");

function showInput(e: MouseEvent) {
  if (!store.state.common.isOwner) {
    visible.value = true;
  }
}

function checkPassword() {
  confirmLoading.value = true;
  apis.checkPassword.request<Result<boolean>>({ password: password.value }).then((res) => {
    if (res.code == 1 && res.data) {
      store.commit("common/setIsOwner", true);
      confirmLoading.value = false;
      visible.value = false;
      message.info("已进入管理状态");
    } else {
      confirmLoading.value = false;
      message.error("密码错误");
    }
  });
}

function logout() {
  if (store.state.common.isOwner) {
    store.commit("common/setIsOwner", false);
    message.info("已退出管理状态");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Menu),
        _createElementVNode("div", {
          class: "header-desc",
          onDblclick: logout,
          onMouseup: _withModifiers(showInput, ["middle"])
        }, _hoisted_6, 40, _hoisted_4)
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "权限验证",
      "ok-text": "确定",
      "cancel-text": "取消",
      "confirm-loading": confirmLoading.value,
      onOk: checkPassword
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: password.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"])
  ]))
}
}

})